import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import KnowledgeBaseEditor from "../components/knowledgebase/KnowledgeBaseEditor";
import { ensureKnowledgeBase } from "../redux/asyncThunk/userActions";
import { CONTENT_TYPES, resolveGameContentType } from "../utils/contentType";
import { userSlice } from "../redux/user/userSlice";
import "./knowledge-base-page.css";

const { selectProject } = userSlice;

export default function KnowledgeBasePage() {
  const dispatch = useDispatch();
  const games = useSelector((state) => state.user?.games);
  const game = useSelector((state) => state.user?.game);
  const user = useSelector((state) => state.user?.data?.user);
  const [bootstrapping, setBootstrapping] = useState(true);

  const knowledgeBaseGame =
    game && resolveGameContentType(game) === CONTENT_TYPES.knowledge_base
      ? game
      : (games ?? []).find(
          (entry) => resolveGameContentType(entry) === CONTENT_TYPES.knowledge_base,
        ) ?? null;

  useEffect(() => {
    if (!user?.id) return;

    let cancelled = false;

    (async () => {
      try {
        const result = await dispatch(ensureKnowledgeBase()).unwrap();
        if (!cancelled && result?.game?._id) {
          dispatch(selectProject(result.game._id));
        }
      } catch {
        // error message handled in slice
      } finally {
        if (!cancelled) {
          setBootstrapping(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, user?.id]);

  if (bootstrapping && !knowledgeBaseGame) {
    return (
      <div className="kb-page kb-page--loading">
        <CircularProgress size={32} />
      </div>
    );
  }

  if (!knowledgeBaseGame) {
    return (
      <div className="kb-page kb-page--empty">
        <div className="kb-page__hero">
          <div className="kb-page__hero-icon">
            <MenuBookOutlinedIcon fontSize="large" />
          </div>
          <h1 className="kb-page__title">База знаний</h1>
          <p className="kb-page__lead">
            Накопленные знания и опыт команды. Сотрудники задают вопросы в
            мессенджере — администратор добавляет ответы текстом, видео или
            картинкой.
          </p>
        </div>
      </div>
    );
  }

  return <KnowledgeBaseEditor game={knowledgeBaseGame} embedded />;
}
